import { storeKindsAggregationFields } from './fragments/store-kinds-aggregation-fields'
import { departmentAggregationFields } from './fragments/department-aggregation-fields'
import { brandAggregationFields } from './fragments/brand-aggregation-fields'
import { sizeTypeAggregationFields } from './fragments/size-type-aggregation-fields'
import { subCategoriesAggregationFields } from './fragments/sub-categories-aggregation-fields'
import { filtersVariables } from './variables/filters-variables'
import { searchProductsWithMetricsDataParams } from './params/search-products-with-metric-data-params'
import { metricDataVariables } from './variables/metric-data-variables'


export const querySearchAggregations = /* GraphQL */ `
  query searchAggregations(
    $term: String!,
    ${filtersVariables},
    ${metricDataVariables}
  ) {
    search(products: ${searchProductsWithMetricsDataParams}) {
      products {
        aggregations {
          store_kinds {
            ...storeKindsAggregationFields
          }
          departments {
            ...departmentAggregationFields
          }
          brands {
            ...brandAggregationFields
          }
          size_types {
            ...sizeTypeAggregationFields
          },
          relevant_sub_categories {
            ...subCategoriesAggregationFields
          }
        }
      }
    }
  }

  ${storeKindsAggregationFields}
  ${departmentAggregationFields}
  ${brandAggregationFields}
  ${sizeTypeAggregationFields}
  ${subCategoriesAggregationFields}
`
